var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var addOrChangeAdditionalInfo = function (originalInfo, newInfo) {
    if (!newInfo || (newInfo === null || newInfo === void 0 ? void 0 : newInfo.length) === 0)
        return originalInfo;
    var newAdditionalInfo = __spreadArray([], (originalInfo || []), true);
    // eslint-disable-next-line no-unused-expressions
    newInfo === null || newInfo === void 0 ? void 0 : newInfo.forEach(function (i) {
        var isExistInfoIndex = newAdditionalInfo === null || newAdditionalInfo === void 0 ? void 0 : newAdditionalInfo.findIndex(function (j) { return (j === null || j === void 0 ? void 0 : j.name) === (i === null || i === void 0 ? void 0 : i.name); });
        if (isExistInfoIndex === -1)
            newAdditionalInfo = __spreadArray(__spreadArray([], newAdditionalInfo, true), [i], false);
        else
            newAdditionalInfo.splice(isExistInfoIndex, 1, i);
        return '';
    });
    return newAdditionalInfo;
};
//# sourceMappingURL=addOrChangeAdditionalInfo.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var addOrChangeAdditionalInfo = function (originalInfo, newInfo) {
    if (!newInfo || (newInfo === null || newInfo === void 0 ? void 0 : newInfo.length) === 0)
        return originalInfo;
    var newAdditionalInfo = __spreadArray([], (originalInfo || []), true);
    // eslint-disable-next-line no-unused-expressions
    newInfo === null || newInfo === void 0 ? void 0 : newInfo.forEach(function (i) {
        var isExistInfoIndex = newAdditionalInfo === null || newAdditionalInfo === void 0 ? void 0 : newAdditionalInfo.findIndex(function (j) { return (j === null || j === void 0 ? void 0 : j.name) === (i === null || i === void 0 ? void 0 : i.name); });
        if (isExistInfoIndex === -1)
            newAdditionalInfo = __spreadArray(__spreadArray([], newAdditionalInfo, true), [i], false);
        else
            newAdditionalInfo.splice(isExistInfoIndex, 1, i);
        return '';
    });
    return newAdditionalInfo;
};
//# sourceMappingURL=addOrChangeAdditionalInfo.js.map